module.exports = __webpack_public_path__ + "static/form-1-cc1979e7f2dece53ac461dbe39542117.jpg";